﻿'user strict';

import { modal } from '../utils/modal';

export const clients = (function () {
    function init(type, format, hidden = false) {
        const _type = type;
        const _format = format;
        const _alert = new Alert('', false);
        const eventName = 'watcherDispatched';
        const event = new Event(eventName);
        const classArr = (hidden) ? ['icon-import', 'hidden'] : ['icon-import'];
        const importButton = toolbar.prepend('a', 'Импорт', classArr);
        const watcher = new Watcher(_type, _format, '/insystem/import/check.cshtml');
        let drop;
        let importModal;
        let _id;

        const start = async (result) => {
            importModal.addSpinner();
            document.addEventListener(eventName, async function (e) {
                importModal.removeSpinner();
                const command = commandList.get(e.detail.data.status);
                if (command !== null)
                    command.Invoke(e.detail);
                else console.error(e + ': wrong data struct or empty!');
            })

            event.detail = await watcher.Request();
            
            document.dispatchEvent(event);
        };

        const empty = (result) => {
            importModal.clear();
            importModal.append(getSampleLink('/insystem/import/samples/sample_clients.xlsx', 'Скачать образец заполнения', 'success'));
            importModal.append(drop.getForm());
            _id = 0;
        };

        const validating = async (result) => {
            _id = 0;
            importModal.clear();
            _alert.message(result.data.message);

            let abortLink = document.createElement('a');
            abortLink.setAttribute('href', '#');
            abortLink.setAttribute('data-link', `/insystem/import/abort.cshtml?id=${result.data.id}`);
            abortLink.setAttribute('role', 'button');
            abortLink.innerText = 'Прервать';

            abortLink.addEventListener('click', (e) => {
                watcher.PollEnd();
                importModal.clear();
                importModal.append(drop.getForm());
                fetch(abortLink.getAttribute('data-link'),
                    {
                        method: 'POST',
                        credentials: 'include'
                    });
            }, false);

            _alert._alert.append(abortLink);

            importModal.prepend(_alert.get());
            importModal.addSpinner();


            event.detail = await watcher.PollStart();
            importModal.removeSpinner();

            document.dispatchEvent(event);
        };

        const outOffTariff = (result) => {
            _id = result.data.id;
            importModal.clear();
            _alert.error(result.data.error);
            importModal.prepend(_alert.get());
            importModal.append(drop.getForm());
        }
         
        const validated = (result) => {
            _id = 0;
            importModal.clear();
            importModal.addSpinner();
            Reload();
        };

        const handleAbortion = async (link) => {
            
            const response = await fetch(link, {
                method: 'POST',
                data: JSON.stringify({}),
                credentials: 'include',
            });

            const headers = await response.headers.get('content-type');

            if (headers == 'application/json; charset=utf-8') {
                event.detail = await response.json();
            } else {
                event.detail = await response.text();
                console.log("response is: ", headers);
            }

            document.dispatchEvent(event);
        };

        const needFix = (result) => {
            _id = result.data.id;

            importModal.clear();
            _alert.warning(result.data.message);
            importModal.prepend(_alert.get());
            importModal.appendAsHtml(`<a class="btn btn-info mb-3 mr-2" href="${result.data.link}?id=${result.data.id}">Скачать документ для исправления</a>`);

            let abortLink = document.createElement('a');
            abortLink.setAttribute('href', '#');
            abortLink.setAttribute('data-link', `/insystem/import/abort.cshtml?id=${result.data.id}`);
            abortLink.setAttribute('role', 'button');
            abortLink.innerText = 'Загрузить заново';
            abortLink.classList.add('btn', 'btn-success', 'mb-3', 'mr-2');
            abortLink.addEventListener('click', async (e) => {
                await handleAbortion(abortLink.getAttribute('data-link'));
            }, false);

            importModal.append(abortLink);
        };


        const error = (result) => {
            importModal.clear();
            _alert.error(result.data.error);
            importModal.prepend(_alert.get());
            importModal.append(drop.getForm());
        };


        const abort = (result) => {
            _id = 0;
            importModal.clear();
            importModal.append(getSampleLink('/insystem/import/samples/sample_clients.xlsx', 'Скачать образец заполнения', 'success'));
            _alert.success(result.data.error);
            importModal.prepend(_alert.get());
            importModal.append(drop.getForm());
        };


        const commandList = (function () {
            const commandList = [

                new Command("Start", start),
                new Command("Empty", empty),
                new Command("Validating", validating),
                new Command("Validated", validated),
                new Command("NeedFix", needFix),
                new Command("Aborted", abort),
                new Command("Error", error),
                new Command("OutOffTariff", outOffTariff),

            ];
            function get(key) {
                const commands = commandList.filter(command => command._name == key);
                const command = (commands.length > 0) ? commands[0] : null;

                return command;
            }
            return {
                get
            }
        })();

        importButton.addEventListener('click', () => {

            importModal = new modal.Modal('import', 'Импорт', 'lg');
            drop = new dropzone.Dropzone('excel');

            commandList.get("Start").Invoke();

            drop.init(async function (files) {
                console.table(files);

                importModal.addSpinner();
                
                event.detail = await sendFile(files, _type, _format, _id);
                document.dispatchEvent(event);
            });


            importModal.event('hidden.bs.modal', () => {
                importModal.clear();
                watcher.PollEnd();
                if (eventName in document)
                    document.removeEventListener(eventName, event);
            });


            importModal.show();
        });


        function getSampleLink(url, text, bootType) {
            let downloadLink = document.createElement(`a`);
            downloadLink.setAttribute("href", url);
            downloadLink.classList.add('btn', `btn-${bootType}`, 'mb-3');
            downloadLink.textContent = text;
            return downloadLink;
        }
    };

    async function sendFile(files, type, format, id) {
        let maxFileSize = 5242880;
        let i = 0;
        for (var file of files) {
            if ((file.size <= maxFileSize)
                /*&& ((file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                    (file.type == 'application/vnd.ms-excel'))*/) {
                let Data = new FormData();

                Data.append(i++, file);
                Data.append('type', type);
                Data.append('format', format);
                Data.append('id', id);

                let request = await fetch(`/insystem/import/import.cshtml`,
                    {
                        method: 'POST',
                        body: Data,
                        credentials: 'include'
                    });

                let result = await request.json();

                return result;
            }
            else {
                alert(`Неверный формат или размер: ${file.name}.\n Добавьте файл в формате ".xls" или ".xlsx" и размером не более 5 Мб`);
            }
        };
    }
    return {
        init
    };
})();